export default __webpack_public_path__ + "static/media/bathroom1-after-768w.37ee89a0.avif";